var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTypeOfBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.903 9.327a.997.997 0 00-.196-.293l-6-6a.998.998 0 00-.293-.196c-.03-.014-.062-.022-.094-.033a.992.992 0 00-.259-.051c-.021-.002-.04-.013-.061-.013H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-11c0-.021-.011-.04-.013-.062a.954.954 0 00-.051-.26c-.01-.031-.019-.062-.033-.092zm-3.317-.586H14V6.155l2.586 2.586zM6 20.74v-16h6v5a1 1 0 001 1h5l.002 10H6z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.74h8v2H8v-2zm0 4h8v2H8v-2zm0-8h2v2H8v-2z",
    fill: "gray"
  })));
}

export default SvgIconTypeOfBusiness;